import { MenuOutlined } from '@ant-design/icons';
import styled from 'styled-components';

export const Wrapper = styled.div`
  position: absolute;
  top: 32px;
  right: 16px;
`;

export const Menu = styled(MenuOutlined)`
  height: 32px;
  width: 32px;

  & svg {
    width: inherit;
    height: inherit;
  }
`;
